export function formatMoney(money?: number): string {
  return money
    ? money.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      })
    : "R$ 0,00";
}
